import { ArticleAny } from "@/types";
import { IAssetSummaryInvalidFields } from "components/AssetSummary/AssetSummary";
import Asset from "models/Asset";
import { AssetStep } from "pages/AssetPage/config";
import { createContext, FC, useContext } from "react";

export interface IAssetInternalNotesEdit {
    canEdit: boolean
    editingContext: 'pinned' | 'section' | null
    savedNotes: string
    notesValue: string
    setNotesValue: (v: string) => void
    startEdit: (context: 'pinned' | 'section') => void
    handleSave: () => void
    handleCancel: () => void
    handleBlur: () => void
    onToolbarPointerDown: () => void
}

interface IAssetDataContext {
    asset: Asset
    article: ArticleAny
    placement: "sidebar" | "summary"
    invalidFields?: IAssetSummaryInvalidFields
    pinnable?: boolean
    onEditClick?: (step: AssetStep) => void
    getEditLink?: (step: AssetStep) => string
    internalNotesEdit?: IAssetInternalNotesEdit
}

export const AssetDataContext = createContext<IAssetDataContext | null>(null)

export const useAssetDataContext = () => {
    const context = useContext(AssetDataContext)
    if (!context) throw new Error("useAssetDataContext must be used within an AssetDataContextProvider")
    return context
}

export const AssetDataContextProvider: FC<React.PropsWithChildren<IAssetDataContext>> = ({
    children,
    ...value
}) => {
    return (
        <AssetDataContext.Provider value={value}>
            {children}
        </AssetDataContext.Provider>
    )
}